import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr';
import Constants from '@/constants';
import ChatHub from '@/chat-hub';

export default class ChatHubInstaller {
  install(Vue: any) {
    const connection = new HubConnectionBuilder()
      .withUrl(Constants.baseUrl + '/signalr')
      .configureLogging(LogLevel.Information)
      .build();

    let startedPromise: any = null;
    function start() {
      startedPromise = connection.start().catch(err => {
        console.error('Failed to connect with hub', err);
        return new Promise((resolve, reject) =>
          setTimeout(
            () =>
              start()
                .then(resolve)
                .catch(reject),
            5000
          )
        );
      });
      return startedPromise;
    }
    connection.onclose(() => start());

    start();

    const chatHub = new ChatHub(connection, startedPromise);
    Vue.prototype.$chatHub = chatHub;

    connection.on('ReceiveMessage', message => {
      chatHub.$emit('ReceiveMessage', message);
    });

    connection.on('ReceiveTechMessage', message => {
      chatHub.$emit('ReceiveTechMessage', message);
    });

    connection.on('ReceiveAdministratorMessage', message => {
      chatHub.$emit('ReceiveAdministratorMessage', message);
    });

    connection.on('ReceiveTechRequsetMessage', message => {
      chatHub.$emit('ReceiveTechRequsetMessage', message);
    });

    connection.on('ReceiveSystemNotificationMessage', message => {
      chatHub.$emit('ReceiveSystemNotificationMessage', message);
    });

    connection.on('ReceiveAdministratorRequsetMessage', message => {
      chatHub.$emit('ReceiveAdministratorRequsetMessage', message);
    });

    connection.on('LoadMessages', messages => {
      chatHub.$emit('LoadMessages', messages);
    });

    connection.on('LoadSystemNotificationMessages', messages => {
      chatHub.$emit('LoadSystemNotificationMessages', messages);
    });

    connection.on('UnreadMessagesCount', unreadMessagesCount => {
      chatHub.$emit('UnreadMessagesCount', unreadMessagesCount);
    });

    connection.on('UnreadTechRequestMessagesCount', unreadMessagesCount => {
      chatHub.$emit('UnreadTechRequestMessagesCount', unreadMessagesCount);
    });

    connection.on('UnreadSystemNotificationMessagesCount', unreadMessagesCount => {
      chatHub.$emit('UnreadSystemNotificationMessagesCount', unreadMessagesCount);
    });

    connection.on('UnreadAdministratorMessagesCount', unreadMessagesCount => {
      chatHub.$emit('UnreadAdministratorMessagesCount', unreadMessagesCount);
    });
  }
}
